// Bit flags for dynamic count queries
export const COUNT_FLAGS = {
  // Individual entity counts (powers of 2)
  LIT_GROUPS: 0b0000000001,  // 1
  BOOKS: 0b0000000010,  // 2
  CHARACTERS: 0b0000000100,  // 4
  VARIATIONS: 0b0000001000,  // 8
  AUTHORS: 0b0000010000,  // 16
  PORTFOLIOS: 0b0000100000,  // 32
  VOICE_ACTORS: 0b0001000000,  // 64
  OPPORTUNITIES: 0b0010000000,  // 128
  RECORDINGS: 0b0100000000,  // 256
  APPLICATIONS: 0b1000000000,  // 512

  // Composite flags for common combinations
  BOOK_CREATOR_BASICS: 0b0000000011,  // LIT_GROUPS | BOOKS (3)
  BOOK_FULL_HIERARCHY: 0b0000001111,  // LIT_GROUPS | BOOKS | CHARACTERS | VARIATIONS (15)
  VOICE_ACTOR_BASICS: 0b0001100000,  // PORTFOLIOS | VOICE_ACTORS (96)
  VOICE_ACTOR_FULL: 0b0101101100,  // PORTFOLIOS | VOICE_ACTORS | CHARACTERS | VARIATIONS | RECORDINGS (428)
  OPPORTUNITY_FULL: 0b1010000000,  // OPPORTUNITIES | APPLICATIONS (640)

  // Special flags for detailed breakdowns
  OPPORTUNITY_BREAKDOWN: 0b10000000000,  // 1024 - Get status-specific counts
  RECORDING_BREAKDOWN: 0b100000000000, // 2048 - Get recording status counts

  // Convenience combinations
  ALL_COUNTS: 0b1111111111,  // Everything (1023)
  DASHBOARD_VIEW: 0b0010101111,  // Common dashboard items (175)
};

// Helper functions
export const hasFlag = (flags, flag) => (flags & flag) === flag;
export const addFlag = (flags, flag) => flags | flag;
export const removeFlag = (flags, flag) => flags & ~flag;

// Get human-readable description of flags
export const describeFla = (flags) => {
  const descriptions = [];
  for (const [name, value] of Object.entries(COUNT_FLAGS)) {
    if (hasFlag(flags, value) && !name.includes('_')) {
      descriptions.push(name);
    }
  }
  return descriptions.join(', ');
};
